import { render, staticRenderFns } from "./selectorPatient.vue?vue&type=template&id=5a1231a2&scoped=true"
import script from "./selectorPatient.vue?vue&type=script&lang=js"
export * from "./selectorPatient.vue?vue&type=script&lang=js"
import style0 from "./selectorPatient.vue?vue&type=style&index=0&id=5a1231a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1231a2",
  null
  
)

export default component.exports